/**
 * Handle application theme
 */
export enum ApplicationTheme {
  UNKNOWN = 0,
  BIG = 1,
  DIGITAL_PLACE = 2,
  BLUMOTIX = 3,
  SMART_HUB = 4,
  VIMAR = 5,
  DREX = 6,
  MDT = 7,
}

/** Handle source image tyèe handling */
export enum SourceImage {
  FROM_CAMERA = 0,
  FROM_FILE = 1,
}

/**
 * Handle toast type to show in different context
 */
export enum ToastType {
  INFO = 0,
  ERROR = 1,
  SUCCESS = 2,
  WARNING = 3,
}

//#region Enums related to Access Control (card's) manufacturer systems
/**
 * Handle system manufacturer system
 */
export enum ManufacturerSystem {
  UNKNOWN = -1,
  AMBIGOUS = 0,
  NONE = 1,
  VIMAR_EELECTRON = 2,
  VIMAR_WELL_CONTACT_PLUS = 3,
  SCHNEIDER = 4,
  SIEMENS = 5,
  EELECTRON = 6,
  GEWISS = 7,
  ABB_MAC2 = 8,
  ELECTRONE = 9,
  MODBUS = 10,
  BLUMOTIX_5 = 11,
  MBUS = 12,
  BLUEWAVE = 13,
  DORMAKABASAFLOKSYSTEM6000 = 14,
  ABB = 15,
  INTESIS = 16,
  BLUMOTIX_10 = 17,
  ESPA = 18,
  SALTO_IS = 19,
  AXIS = 20,
  WEIGAND = 21,
  LORA = 22,
  ABB_MILLENIUM = 23,
  ABB_TACTEO = 24,
  BACNET = 25,
  BECKHOFF = 26,
  CISA = 27,
  DAHUA = 28,
  MQTT = 29,
  BIG_VIRTUAL = 30,
  API = 31,
  MIKROTIK = 32,
  BIG = 33,
  DAHUA_CARD_READER = 34,
  BIG_VIRTUAL_KEYPAD = 35,
  GENERIC_KEYPAD = 36,
  SALTO_KS = 37,
  EELECTRON_MIFARE = 38,
  TECNOALARM = 39,
  LUTRON = 40,
  SINAPSI = 41,
  BTICINO = 42,
  VIMAR_BYME = 43,
  BIG_VIRTUAL_MIFARE = 44,
  CLOUD = 45,
  BLUMOTIX_2023 = 46,
  EELECTRON_KEYPAD = 49,
  CONNECT_BOX = 50,
  AKUVOX_KEYPAD = 51,
  AKUVOX_CARD_READER = 52,
  BLUMOTIX_2025_KEYPAD = 53,
  BLUMOTIX_2025_MIFARE = 54,
  VIMAR_WELL_CONTACT_PLUS_2026 = 55,
  CIE = 56,
  /**ATTENTION: This item is ONLY used in conjucntion with a specific "EnvironmentAccessControlMaintanance" object's
   * "manufacturerSystem" property to identify the "cardKind" of a card associated with that environment as "PLATE".
   */
  MULTI_MANUFACTURERSYSTEM = 99,
  ANDROID = 998,
  IOS = 999,
  MYTO = 997,
}

/**This enum collects the accessControl manufacturer Systems belonging to the "ABB family".
 * This is used to groups all the systems which share similar characteristics in terms of REAL CARD
 * reading/writing procedures.
 *
 * NOTE: the items of this enum are EXACT COPIES of the equivalent ones in "ManufacturerSystem" enum.
 */
export enum ABBManufacturerSystemWRFamily {
  //ABB_MAC2 = ManufacturerSystem.ABB_MAC2,
  ABB_MILLENIUM = ManufacturerSystem.ABB_MILLENIUM,
  ABB_TACTEO = ManufacturerSystem.ABB_TACTEO,
}

/**This enum collects the accessControl manufacturer Systems belonging to the "WCP family".
 * This is used to groups all the systems which share similar characteristics in terms of REAL CARD
 * reading/writing procedures.
 *
 * NOTE: please pay attention to the "VIMAR_WELL_CONTACT_PLUS_2026" item; this is a special case, since this single
 * manucturer Systems supports the writing of its cards both via MIFARE and DESFIRE pshysical-card technologies.
 */
export enum WCPManufacturerSystemWRFamily {
  VIMAR_WELL_CONTACT_PLUS = ManufacturerSystem.VIMAR_WELL_CONTACT_PLUS,
  VIMAR_WELL_CONTACT_PLUS_2026 = ManufacturerSystem.VIMAR_WELL_CONTACT_PLUS_2026,
  AKUVOX_CARD_READER = ManufacturerSystem.AKUVOX_CARD_READER,
}

/** This enum collects the accessControl manufacturer systems that are writable via NFC on the application running on
 * a  mobile device.
 * This is used to group all the systems which support NFC writing from mobile devices.
 */
export enum MobileNFCWritableManufacturerSystems {
  VIMAR_WELL_CONTACT_PLUS = ManufacturerSystem.VIMAR_WELL_CONTACT_PLUS,
  VIMAR_WELL_CONTACT_PLUS_2026 = ManufacturerSystem.VIMAR_WELL_CONTACT_PLUS_2026,
  AKUVOX_CARD_READER = ManufacturerSystem.AKUVOX_CARD_READER,
  ABB_MILLENIUM = ManufacturerSystem.ABB_MILLENIUM,
  ABB_TACTEO = ManufacturerSystem.ABB_TACTEO,
  BIG_VIRTUAL_MIFARE = ManufacturerSystem.BIG_VIRTUAL_MIFARE,
  BLUMOTIX_2025_MIFARE = ManufacturerSystem.BLUMOTIX_2025_MIFARE,
}

/**
 * This enum collects  the accessControl manufacturer systems that are considered "unknow", which are assigned by the
 * system to device that, altough existing, have NOT been configured with a known/integrated manufacturer system.
 */
export enum UnknownManufacturerSystems {
  UNKNOWN = ManufacturerSystem.UNKNOWN,
  AMBIGOUS = ManufacturerSystem.AMBIGOUS,
  NONE = ManufacturerSystem.NONE,
}

/**
 * This enum collects the accessControl manufacturer systems that support the writing of their cards
 * both via MIFARE and DESFIRE pshysical-card technologies.
 * 
 * This also means that the presence of these manufacturer systems DOES NOT imply the use of any specific physical-card technology
 * in the definition of the NFC writing/reading procedures.
 */
export enum MifareDesfireTechManufacturerSystems {
  VIMAR_WELL_CONTACT_PLUS_2026 = ManufacturerSystem.VIMAR_WELL_CONTACT_PLUS_2026,
}

/**
 * This enum collects the accessControl manufacturer systems that support the writing of their cards ONLY
 * via DESFIRE pshysical-card technologies.
 * 
 * This also means that the presence of these manufacturer systems DOES imply the use of the specific physical-card technology
 * "DESFIRE" in the definition of the NFC writing/reading procedures.
 */
export enum DesfireOnlyTechManufacturerSystems {
  //STUB: no manufacturer system is currently in this category
}


/**
 * This enum collects the accessControl manufacturer systems that support the writing of their cards
 * only via MIFARE pshysical-card technologies.
 * 
 * This also means that the presence of these manufacturer systems DOES imply the use of the specific physical-card technology
 * "MIFARE" in the definition of the NFC writing/reading procedures.
 */
export enum MifareOnlyTechManufacturerSystems {
  VIMAR_EELECTRON = ManufacturerSystem.VIMAR_EELECTRON,
  VIMAR_WELL_CONTACT_PLUS = ManufacturerSystem.VIMAR_WELL_CONTACT_PLUS,
  SCHNEIDER = ManufacturerSystem.SCHNEIDER,
  SIEMENS = ManufacturerSystem.SIEMENS,
  EELECTRON = ManufacturerSystem.EELECTRON,
  GEWISS = ManufacturerSystem.GEWISS,
  ABB_MAC2 = ManufacturerSystem.ABB_MAC2,
  ELECTRONE = ManufacturerSystem.ELECTRONE,
  MODBUS = ManufacturerSystem.MODBUS,
  BLUMOTIX_5 = ManufacturerSystem.BLUMOTIX_5,
  MBUS = ManufacturerSystem.MBUS,
  BLUEWAVE = ManufacturerSystem.BLUEWAVE,
  DORMAKABASAFLOKSYSTEM6000 = ManufacturerSystem.DORMAKABASAFLOKSYSTEM6000,
  ABB = ManufacturerSystem.ABB,
  INTESIS = ManufacturerSystem.INTESIS,
  BLUMOTIX_10 = ManufacturerSystem.BLUMOTIX_10,
  ESPA = ManufacturerSystem.ESPA,
  SALTO_IS = ManufacturerSystem.SALTO_IS,
  AXIS = ManufacturerSystem.AXIS,
  WEIGAND = ManufacturerSystem.WEIGAND,
  LORA = ManufacturerSystem.LORA,
  ABB_MILLENIUM = ManufacturerSystem.ABB_MILLENIUM,
  ABB_TACTEO = ManufacturerSystem.ABB_TACTEO,
  BACNET = ManufacturerSystem.BACNET,
  BECKHOFF = ManufacturerSystem.BECKHOFF,
  CISA = ManufacturerSystem.CISA,
  DAHUA = ManufacturerSystem.DAHUA,
  BIG_VIRTUAL = ManufacturerSystem.BIG_VIRTUAL,
  MIKROTIK = ManufacturerSystem.MIKROTIK,
  BIG = ManufacturerSystem.BIG,
  DAHUA_CARD_READER = ManufacturerSystem.DAHUA_CARD_READER,
  SALTO_KS = ManufacturerSystem.SALTO_KS,
  EELECTRON_MIFARE = ManufacturerSystem.EELECTRON_MIFARE,
  TECNOALARM = ManufacturerSystem.TECNOALARM,
  LUTRON = ManufacturerSystem.LUTRON,
  SINAPSI = ManufacturerSystem.SINAPSI,
  BTICINO = ManufacturerSystem.BTICINO,
  VIMAR_BYME = ManufacturerSystem.VIMAR_BYME,
  BIG_VIRTUAL_MIFARE = ManufacturerSystem.BIG_VIRTUAL_MIFARE,
  CLOUD = ManufacturerSystem.CLOUD,
  BLUMOTIX_2023 = ManufacturerSystem.BLUMOTIX_2023,
  CONNECT_BOX = ManufacturerSystem.CONNECT_BOX,
  AKUVOX_KEYPAD = ManufacturerSystem.AKUVOX_KEYPAD,
  AKUVOX_CARD_READER = ManufacturerSystem.AKUVOX_CARD_READER,
  BLUMOTIX_2025_MIFARE = ManufacturerSystem.BLUMOTIX_2025_MIFARE,
}


//#endregion

/**
 * This enum stores all time-related keywords to be replaced with puntual time-values in graphical-component "text" property.
 * ATTENTION: the order of the keyword  IS PARAMOUNT: all substrings should ALWAYS be BELOW their "super-strings".
 */
export enum TimeRelatedKeywords {
  CLOCKSHORT = "#clockshort",
  CLOCK = "#clock",
  HOURS2DIGITS = "#hours2digits",
  HOURS = "#hours",
  MINUTES2DIGITS = "#minutes2digits",
  MINUTES = "#minutes",
  SECONDS2DIGITS = "#seconds2digits",
  SECONDS = "#seconds",
  DATESHORT = "#dateshort",
  DATE = "#date",
  DAY2DIGITS = "#day2digits",
  DAYNAMESHORT = "#daynameshort",
  DAYNAME = "#dayname",
  DAY = "#day",
  MONTH2DIGITS = "#month2digits",
  MONTHNAMESHORT = "#monthnameshort",
  MONTHNAME = "#monthname",
  MONTH = "#month",
  YEAR2DIGITS = "#year2digits",
  YEAR = "#year",
}

export enum OtherKeyWords {
  /**Mostra il valore attuale dell'indirizzo di stato */ //
  VALUE = "#value",
  /**Mostra il valore dell'indirizzo di stato formattato in base alla tipologia dell'indirizzo */
  FORMATTEDVALUE = "#formattedvalue",
  /**Mostra la data e ora dell'ultimo valore ricevuto sull'indirizzo di stato */
  TIMESTAMP = "#timestamp",
  /**Mostra il nome dell’indirizzo di stato */
  NAME = "#name",
  /**Mostra il nome completo dell'indirizzo di stato, comprensivo dell'eventuale gerarchia di nodi*/
  FULLNAME = "#fullname",
  /**Mostra l'indirizzo di stato */
  ADDRESS = "#address",
  /**Mostra il formato dell'indirizzo di stato */
  HILEVELDATAFORMAT = "#hileveldataformat",
  /**Mostra il valore attuale dell'indirizzo di stato così come ricevuto dal bus (grezzo) */
  TECHVALUE = "#techvalue",
  /**Mostra l'unità di misura associata all'indirizzo */
  MEASUREUNIT = "#measureunit",
  /**Mostra il numero dell'ambiente a cui è associato l'indirizzo di stato; questa parola chiave va usata solo nel caso in cui l'indirizzo sia associato ad un solo dispositivo posizionato in un solo ambiente, in questo modo il valore assegnato dalla parola chiave è univoco. In caso contrario viene mostrata la prima relazione trovata con un ambiente (non sempre significativa) */
  ROOMNUMBER = "#roomnumber",
  /**Mostra il nome dell'ambiente  a cui è associato l'indirizzo di stato; valgono le precauzioni da usare per #roomnumber */
  ROOMNAME = "#roomname",
  /**Mostra il numero dell'ambiente a cui è associato l'indirizzo di stato; questa parola chiave va usata solo nel caso in cui l'indirizzo sia associato ad un solo dispositivo posizionato in un solo ambiente, in questo modo il valore assegnato dalla parola chiave è univoco. In caso contrario viene mostrata la prima relazione trovata con un ambiente (non sempre significativa) */
  VIRTUALROOMNUMBER = "#virtualroomnumber",
  /**Mostra il nome dell'ambiente a cui è associato l'indirizzo di stato; questa parola chiave va usata solo nel caso in cui l'indirizzo sia associato ad un solo dispositivo posizionato in un solo ambiente, in questo modo il valore assegnato dalla parola chiave è univoco. In caso contrario viene mostrata la prima relazione trovata con un ambiente (non sempre significativa) */
  VIRTUALROOMNAME = "#virtualroomname",
  /**Dato un indirizzo con valore decimale definisce il numero di decimali (N) da far vedere */
  DECIMALDIGITSN = "#decimaldigitsN",
  /**Mostra il valore intero dell'indirizzo come periodo temporale */
  HOURMETER = "#hourmeter",
  /**Elimina i primi n elementi dalla stringa valore */
  TRIMELEFT = "#trimleft(valore,n)",
  /**Elimina gli ultimi n elementi dalla stringa valore */
  TRIMERIGHT = "#trimright(valore,n)r",
}

/**
 * Enum to handle toast disconnection state
 */
export enum ToastConnectionCodes {
  MQTT_CONNECTION_LOST = 1,
  MQTT_CONNECTION_REGAIN = 2,
  API_CONNECTION_LOST = 3,
  API_CONNECTION_REGAIN = 4,
  API_MQTT_CONNECTION_LOST = 5,
}

/**
 * Enum specifyng all possible type of date/time string format. The string format themselves are specified in "AppSettings.ts"
 */
export enum DateTimeStringFomat {
  /**Format date following pattend "DD-MM-YYYY" */
  SHORT_DATE_STRAIGHT = 1,
  /**Format date following pattend "YYYY-MM-DD" */
  SHORT_DATE_INVERSE = 2,
  /**Format date following pattend "D-MM-YYYY" */
  SHORT_DATE_STRAIGHT_SIGLE_DAY = 3,
  /**Format date following pattend "DD-M-YYYY" */
  SHORT_DATE_STRAIGHT_SIGLE_MONTH = 4,
  /**Format date following pattend "D-M-YYYY" */
  SHORT_DATE_STRAIGHT_SIGLE_DAY_MONTH = 5,
  /**Format date following pattend "DDMMYYYY" */
  SHORT_DATE_STRAIGHT_NO_SEPARATORS = 6,
  /**Format date following pattend "HH:mm" */
  LONG_HOUR_LONG_MINUTES = 7,
  /**Format date following pattend "H:mm" (24-hour based, BUT without initial ZERO for hours)*/
  SHORT_HOUR_LONG_MINUTES = 8,
  /**Format date following pattend "HH:m" (24-hour based, BUT without initial ZERO for minutes)*/
  LONG_HOUR_SHORT_MINUTES = 9,
  /**Format date following pattend "H:m" (24-hour based, BUT without initial ZERO for both hour AND minutes)*/
  SHORT_HOUR_SHORT_MINUTES = 10,
  /**Format date following pattend "HHmm" (24-hour based, BUT without separation between hours and minutes)*/
  LONG_HOUR_LONG_MINUTES_NO_SEPARATION = 11,
  /**Format date following pattern "DD/MM/YYYY" */
  SHORT_DATE_STRAIGHT_SLASH = 12,
}

/**This enum lists all the possible steps for time/date selection.
 * It is used in time/date-picker components to define the step of the minutes/hours/days selection.
 */
export enum TimeDateSelectionSteps {
  TIME_DATE_DEFAULT = 0,
  TIME_5_MINUTES = 1,
}

/**
 * Enum specifying all the possible cases where a data retrieval from the WebServer API by the app is subjected to failure.
 * These are used to define the particular strategy to be used to handle the data retrieval.
 */
export enum DataRetrievalErrorCase {
  /**
   * In this SPECIAL case, the data are NOT EVEN RETRIEVED one time; simply, the feature the data-retireval would be tied to is NOT SUPPORTED BY THE API SERVER.
   * This lack of feature is detected by the client application not based on the answer of the "main" API call, by other means
   * (FOR EXAMPLE, by checking the actual API version of teh API Server against a minimum required version for the feature, through the "Utility.service£" method
   * "checkIfMinimumRequiredVersionIsReached(...)").
   *
   * HANDLING STRATEGY:
   *
   * * Error-content.component:
   *
   * **Pass to it the custom text "dictionary.notSupportedRequestUpdate" to underline the special nature of the problem.
   * **DO NOT launch "MAIN_TIMER". No automatic retry of data retrieval will be initialised from here or elsewhere
   *
   * **DO NOT DISPLAY ""Manual reload" button.
   *
   * **DISPLAY customized warning "The feature is currently not supported by server"
   */
  ERROR_FEATURE_UNSUPPORTED = 0,

  /**In this case, the API WebServer is unreachable EITHER because tha client device has lost connection to the network
   * (CHROMIUM CODE: net:: ERR_ADDRESS_UNREACHABLE) OR
   * connection to the network/server machine has been established, BUT the API Webserver doesn't unswer (CHROMIUM CODE: net::ERR_CONNECTION_REFUSED)
   *
   * HANDLING STRATEGY:
   *
   * * Error-content.component:
   *
   * **DO NOT launch "MAIN_TIMER":  Data Service will be DIRECTLY notify to retrieve
   * again data BY "Network.service" through "OnComeBackOnline" subject when connection to WebServer API is re-estabilished.
   *
   * **DO NOT display "Manual reload" button.
   */
  ERROR_WEBSERVER_UNREACHABLE = 1,

  /**In this case, the HTTP Response for a HTTP Request (for data) launched by the client is NOT recieved before the passing of the "httpRequestTimeout"
   *  time-out timer set by "Authentication-inteceptor". Therefore, the HTTP Request is CANCELLED by the client itself (CHROMIUM CODE: net::ERR_CONNECTION_TIMED_OUT).
   *
   *  HANDLING STRATEGY:
   *
   * * Error-content.component:
   *
   * ** LAUNCH the "MAIN_TIMER"; when it is exhausted after "_intervalRetryReload" ms, it notify the parent Page/Component to ask again to the
   * competent data Services to to retrieve again data.
   *
   * ** DISPLAY ""Manual reload" button.
   *
   * ** DISPLAY count-down to exhaustion of  "MAIN_TIMER" and next attempt of data retrieval.
   */
  ERROR_CLIENT_CONNECTION_CANCELLED = 3,

  /**
   * In this case, the HTTP Request received by the API WebServer from the client is CANCELLED BY THE WEBSERVER, because of a violation of some of its
   * internal time-out periods.
   *
   * *  HANDLING STRATEGY: TO BE DEFINED.
   *
   */
  ERROR_WEBSERVER_CONNECTION_CANCELLED = 4,

  /**
   * In this case, the client recived an the HTTP Response with a HTTP Error Code 400. This is usually a client-side error in the HTTP REquest definition.
   * HOWEVER, it can also be caused BY THE WEBSERVER API/ IIS, due to an axhaustion of server resources (RAM, SQL COnnections etc.) which makes responding to an HTTP
   * REquest impossible.
   *
   * HANDLING STRATEGY: SAME AS "ERROR_CLIENT_CONNECTION_CANCELLED"
   *
   * * Error-content.component:
   *
   * ** LAUNCH the "MAIN_TIMER"; when it is exhausted after "_intervalRetryReload" ms, it notify the parent Page/Component to ask again to the
   * competent data Services to to retrieve again data.
   *
   * ** DISPLAY ""Manual reload" button.
   *
   * ** DISPLAY count-down to exhaustion of  "MAIN_TIMER" and next attempt of data retrieval.
   *
   */
  ERROR_WEBSERVER_CANCELLED_400 = 5,

  /**
   * In this case, the client recieved an the HTTP Response with a HTTP Error Code 401. This happens when the HTTP Request contains a Request header "Authorization" with a wrong/
   * exhausted AuthenticationToken.
   *
   * HANDLING STRATEGY:
   *
   * * Error-content.component:
   *
   * NOTE: The component is actually showed NOT for the FIRST HTTP Error Code 401, but ONLY if the consequent HTTP Request "POST /api/authentication//refreshtoken"
   * has itself terminated with an ERROR.
   *
   * **DO NOT launch "MAIN_TIMER": Specific strategy to handle peculiar HTTP ERROR CASE which befalled the "POST /api/authentication//refreshtoken"
   * Request will be defined inside the "Authetication-interceptor.service"
   *
   * **DO NOT display "Manual reload" button.
   *
   * **DISPLAY customized warning "Authentication Problem detected. Server is working to solve problem..."
   *
   * * Authetication-interceptor.service: TO BE DEFINED
   *
   */
  ERROR_WEBSERVER_FAILED_AUTHENTIATION = 6,

  /**
   * In this case, the client recieved an the HTTP Response with a HTTP Error DIFFERENT FROM EITHER 400, 401, 404 OR 503. This usually signal an error inside the operation of
   * the API WebServer.
   *
   * HANDLING STRATEGY:
   *
   * * Error-content.component:
   *
   * **DO NOT launch "MAIN_TIMER". No automatic retry of data retrieval will be initialised from here or elsewhere
   *
   * **DISPLAY ""Manual reload" button. Manual retry will be however still possible.
   *
   * **DISPLAY customized warning "An internal server error has been detected"
   */
  ERROR_WEBSERVER_GENERIC_ERROR = 7,

  /**
   * In this case, the client recieved an the HTTP Response with a HTTP Error Code 404.
   *
   * HANDLING STRATEGY:
   *
   * * Error-content.component:
   *
   * **DO NOT launch "MAIN_TIMER". No automatic retry of data retrieval will be initialised from here or elsewhere
   *
   * **DISPLAY ""Manual reload" button. Manual retry will be however still possible.
   *
   * **DISPLAY customized warning "An internal server error has been detected: Requested data not found"
   */
  ERROR_WEBSERVER_DATA_NOT_FOUND = 8,

  /**
   * In this case, the client recieved an the HTTP Response with a HTTP Error Code 503.
   *
   * This could happen when an error server-side but NOT in the API WebServer has caused the HTTP Request to return correctly,
   * but with a lacking payload. Example of such error is an "SQL Time-out Error", where the connection open by the API WebServer
   * to the SQL Server to retrieve the data has timed-out (usually due to temporary excessive work on the sqlServer).
   *
   * HANDLING STRATEGY:
   *
   * * Error-content.component:
   *
   * ** LAUNCH the "MAIN_TIMER"; when it is exhausted after "_intervalRetryReload" ms, it notify the parent Page/Component to ask again to the
   * competent data Services to to retrieve again data.
   *
   * ** DISPLAY ""Manual reload" button.
   *
   * ** DISPLAY count-down to exhaustion of  "MAIN_TIMER" and next attempt of data retrieval.
   *
   */
  ERROR_WEBSERVER_SERVICE_UNAVAILABLE = 9,
}
